import { SagaMiddleware } from "redux-saga";
import fetchContent from "./fetchContent";
import fetchAttributes from "./fetchAttributes";
import createProject from "./createProject";
import createCart from "./createCart";
import createOrder from "./createOrder";
import fetchProject from "./fetchProject";

export default function (middleware: SagaMiddleware<{}>) {
    middleware.run(fetchContent);
    middleware.run(fetchAttributes);
    middleware.run(createProject);
    middleware.run(createCart);
    middleware.run(createOrder);
    middleware.run(fetchProject);
}
